import { render, staticRenderFns } from "./fvSlider.vue?vue&type=template&id=5a50ce9a&lang=pug&"
import script from "./fvSlider.vue?vue&type=script&lang=js&"
export * from "./fvSlider.vue?vue&type=script&lang=js&"
import style0 from "./fvSlider.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/framevuerk-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "fvSlider.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/fvSlider.vue
// module id = 162
// module chunks = 0 1